import { module } from "angular";
import { ConfirmPasswordResetComponent } from "./ConfirmPasswordResetComponent";

module("mmAuth").component("irConfirmPasswordReset", new ConfirmPasswordResetComponent());
